import {
    INSTAGRAM,
    FACEBOOK,
    LINKEDIN,
    PINTEREST,
    TWITTER,
    TIKTOK_BUSINESS,
    YOUTUBE
} from '@/lib/socialProfile';
import {
    EngagementInstagram,
    requestInstagramParams,
    requestInstagramOtherParameters
} from './instagram';
import {
    EngagementFacebook,
    requestFacebookParams
} from '@/lib/analytics/pages/engagement/facebook';
import {
    EngagementLinkedin,
    requestLinkedinParams
} from '@/lib/analytics/pages/engagement/linkedin';
import {
    EngagementPinterest,
    requestPinterestParams
} from '@/lib/analytics/pages/engagement/pinterest';
import { EngagementTwitter, requestTwitterParams } from '@/lib/analytics/pages/engagement/twitter';
import {
    EngagementTiktok,
    requestTiktokParams,
    requestTiktokOtherParameters
} from '@/lib/analytics/pages/engagement/tiktok';
import {
    EngagementYoutube,
    requestYoutubeParams,
    requestYoutubeOtherParameters
} from '@/lib/analytics/pages/engagement/youtube';

export const EngagementConfig = (type) => {
    let config;
    let fields;
    let parameters;
    const waitForSPTransition = true;
    switch (type) {
        case INSTAGRAM:
            config = EngagementInstagram;
            fields = requestInstagramParams;
            parameters = requestInstagramOtherParameters;
            break;
        case FACEBOOK:
            config = EngagementFacebook;
            fields = requestFacebookParams;
            break;
        case LINKEDIN:
            config = EngagementLinkedin;
            fields = requestLinkedinParams;
            break;
        case PINTEREST:
            config = EngagementPinterest;
            fields = requestPinterestParams;
            break;
        case TWITTER:
            config = EngagementTwitter;
            fields = requestTwitterParams;
            break;
        case TIKTOK_BUSINESS:
            config = EngagementTiktok;
            fields = requestTiktokParams;
            parameters = requestTiktokOtherParameters;
            break;
        case YOUTUBE:
            config = EngagementYoutube;
            fields = requestYoutubeParams;
            parameters = requestYoutubeOtherParameters;
            break;
    }
    return { config, fields, parameters, waitForSPTransition };
};
